import React from 'react';
import '../css/NextEventOverview.css';
// Top par local vector/illustration image import karne ke liye block
import eventIllustration from '../assets/safety.JPG'; 

const NextEventOverview = () => {
  return (
    <section className="gfi-event-section">
      <div className="gfi-event-container">
        
        {/* LEFT BLOCK: DECORATIVE VECTOR GRAPHICS ARCHITECTURE */}
        <div className="gfi-event-media-side">
          <div className="gfi-vector-wrapper">
            {/* Background floating abstract elements matching image 11 */}
            <div className="gfi-abstract-dots"></div>
            <div className="gfi-abstract-ring"></div>
            
            {/* Main Vector Asset Image */}
            <img 
              src={eventIllustration} 
              alt="Learning and Training Vector Illustration" 
              className="gfi-event-vector-img" 
              onError={(e) => {
                // Fallback icon placeholder if local image is missing initially
                e.target.style.display = 'none';
              }}
            />
          </div>
        </div>

        {/* RIGHT BLOCK: CORE CONTENT DATA FIELD */}
        <div className="gfi-event-content-side">
          <h2 className="gfi-event-main-title">Start With Next Event</h2>
          
          <div className="gfi-event-description-body">
            <p>
              Join our <strong>safety Officer courses</strong> and build your career with the most respected HSE qualifications to contribute to any employer or university requirements. Also, internationally acclaimed <strong>NEBOSH Certificate courses</strong> have the potential to open job opportunities anywhere in the world. We offer you the top-grade safety courses Online at all levels and excellent education faculty to guide you through.
            </p>
            <p>
              To provide the best learning experience, Greenfield Academy is equipped with state-of-the-art facilities, including modern classrooms, specialized training labs, and simulation rooms. Students have access to the latest equipment and technology to enhance their practical skills.
            </p>
          </div>

          {/* Core Crisp Action CTA Button */}
          <div className="gfi-event-action-area">
            <a href="#explore" className="gfi-event-explore-btn">
              Explore Event →
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default NextEventOverview;